"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CommonModule = void 0;
const ferrum_plumbing_1 = require("ferrum-plumbing");
const ApiClient_1 = require("../clients/ApiClient");
const unifyre_extension_web3_retrofit_1 = require("unifyre-extension-web3-retrofit");
const Web3ModalProvider_1 = require("unifyre-extension-web3-retrofit/dist/contract/Web3ModalProvider");
const unifyre_extension_sdk_1 = require("unifyre-extension-sdk");
const blockchain_1 = require("aws-lambda-helper/dist/blockchain");
class DummyStorage {
}
class CommonModule {
    constructor(apiUrl) {
        this.apiUrl = apiUrl;
    }
    async configAsync(c) {
        c.register(ferrum_plumbing_1.LoggerFactory, () => new ferrum_plumbing_1.LoggerFactory(n => new ferrum_plumbing_1.ConsoleLogger(n)));
        c.register('JsonStorage', () => new DummyStorage());
        await c.registerModule(new unifyre_extension_sdk_1.ClientModule('http://', 'BASE'));
        await c.registerModule(new unifyre_extension_web3_retrofit_1.Web3RetrofitModule('BASE', []));
        c.registerSingleton(ApiClient_1.ApiClient, c => new ApiClient_1.ApiClient(this.apiUrl, c.get(unifyre_extension_sdk_1.UnifyreExtensionKitClient)));
        const client = c.get(ApiClient_1.ApiClient);
        const providers = await client.loadHttpProviders();
        const mappedProviders = {
            'ETHEREUM': providers['web3Provider'],
            'RINKEBY': providers['web3ProviderRinkeby'],
            'BSC': providers['web3ProviderBsc'],
            'BSC_TESTNET': providers['web3ProviderBscTestnet'],
            'MUMBAI_TESTNET': providers['web3ProviderMumbaiTestnet'],
            'POLYGON': providers['web3ProviderPolygon'],
        };
        c.registerSingleton('Web3ModalProvider', () => new Web3ModalProvider_1.Web3ModalProvider(mappedProviders));
        c.registerSingleton('EthereumSmartContractHelper', () => new blockchain_1.EthereumSmartContractHelper(mappedProviders));
        // c.registerSingleton(UserPreferenceService, () => new UserPreferenceService());
        // IntlManager.instance.load([stringsEn], 'en-US');
        // IocModule._container = c;
        // init other dependencies
        // c.get<UserPreferenceService>(UserPreferenceService).init(dispatch);
        // PairAddressService
    }
}
exports.CommonModule = CommonModule;
//# sourceMappingURL=Module.js.map